import React, { FunctionComponent } from "react"
import { SchemaField } from "../featuer-layer-settings/schema"
import { FormControlLabel, makeStyles, Theme, Switch } from "@material-ui/core"
import { useFormContext, Controller } from "react-hook-form"

/** BooleanField component props */
interface DNABooleanFieldProps {
  field: SchemaField
}

/** Scoped @material-ui/core stylesheet */
const useStyles = makeStyles<Theme>(theme => ({
  switch: {
    "& .MuiTypography-root": {
      ...theme.typography.button,
      textTransform: "none",
      color:
        theme.palette.type === "dark"
          ? theme.palette.grey[50]
          : theme.palette.grey[800],
    },
  },
}))

export const BooleanField: FunctionComponent<DNABooleanFieldProps> = ({
  field,
}) => {
  /** Get scoped CSS classes */
  const classes = useStyles()

  /** Hook up to the form */
  const { control } = useFormContext()

  return (
    <FormControlLabel
      label={field.alias}
      className={classes.switch}
      control={
        <Controller
          name={field.name || ""}
          control={control}
          defaultValue=""
          render={props => (
            <Switch
              checked={Boolean(props.value)}
              onChange={e => props.onChange(e.target.checked)}
            />
          )}
        />
      }
    />
  )
}
